<template>
  <form class="mt-2" id="form-modal">
    <!-- title input -->
    <div class="form-group">
      <label class="label-form-mini" style="float: left" v-if="$can('lead_create_company_name')">Company Name<span style="color: red">*</span>:</label>
      <label class="label-form-mini" style="float: right" v-if="$can('lead_create_contact_name')">Contact Name<span style="color: red">*</span>:</label>
      <input type="text" id="companyName" class="form-control-mini" v-model="demoForm.companyName"
        placeholder="Company Name*" v-if="$can('lead_create_company_name')" @blur="checkLead"/>
      <input type="text" id="contactName" style="float: right" class="form-control-mini" v-model="demoForm.contactName"
        placeholder="Contact Name*" v-if="$can('lead_create_contact_name')"/>
    </div>
    <div class="form-group">
      <label class="label-form-mini" style="float: left" v-if="$can('lead_create_phone')">Phone(with country code)<span
          style="color: red">*</span>:</label>
      <label class="label-form-mini" style="float: right" v-if="$can('lead_create_email')">Email<span style="color: red">*</span>:</label>
      <input type="text" class="form-control-mini" v-model="demoForm.phone" @input="normalizePhone" placeholder="Phone (with country code)*" v-if="$can('lead_create_phone')"/>
      <input type="email" style="float: right" class="form-control-mini" v-model="demoForm.email" placeholder="Email*" v-if="$can('lead_create_email')"  @blur="checkLead"/>
    </div>
    <div class="form-group" v-if="$can('lead_create_country')">
      <label class="label-form" >Country<span style="color: red">*</span>:</label>
      <multiselect v-model="demoForm.country" :options="countries" :multiple="false" :selectedLabel="null" :deselectLabel="null"  :selectLabel="null" :internal-search="true" :allow-empty="true"></multiselect>
    </div>
    <div class="form-group" v-if="$can('lead_create_website')">
      <label class="label-form">Website<span style="color: red">*</span>:</label>
      <input @keyup="checkWebsiteStatus" type="text" class="form-control" v-model="demoForm.company_url" placeholder="Example : foxtek.com" />
      <font-awesome-icon v-if="isMiniLoading2" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 0px; margin-top: -22px; margin-right:15px;" />
      <span v-show="company_url" style="color: red;  font-size: 10px;">{{ this.company_url }}</span>
    </div>
    
    <div class="form-group" v-if="$can('lead_create_software')">
      <label class="label-form">Software<span style="color: red">*</span>:</label>
      <!-- <multiselect @input="checkWebsiteStatus" v-model="demoForm.lead_for"  :selectedLabel="null" :deselectLabel="null"  :selectLabel="null" :searchable="false" :options="products" :multiple="true" :allow-empty="true"></multiselect> -->
      <multiselect @input="checkWebsiteStatus" :options="products" :multiple="false"  :close-on-select="true" :clear-on-select="false"   
      :selectedLabel="null" :deselectLabel="null" :selectLabel="null" :allow-empty="true" v-model="demoForm.lead_for"
                label="name" track-by="id" style="font-size:12px !important">
              </multiselect>
    </div>
    <div class="form-group"  v-if="$can('lead_create_tags')">
      <label class="label-form">Tags</label>
      <multiselect  v-model="demoForm.selected_tags"  label="tag" track-by="id" :searchable="false"  :options-limit="20" :max-height="130" :selectLabel="null" :selectedLabel="null" :deselectLabel="null" :options="tags" :multiple="true" :allow-empty="true"   :close-on-select="false" :clear-on-select="false"  placeholder="Tags"></multiselect>
    </div>
    <div class="form-group"  v-if="$can('lead_create_tags')">
      <label class="label-form">Lead Type</label>
        <multiselect v-model="demoForm.lead_type" :options="selectLeadList" :multiple="false" :selectedLabel="null" :deselectLabel="null" :allow-empty="false"
        :selectLabel="null" :internal-search="true" label="name" track-by="name" placeholder="lead type">
        </multiselect>
    </div>
    <div class="form-group" v-if="[1,6].includes(role_id)">
        <label class="label-form">Assign Lead</label>
        <multiselect  v-model="demoForm.selected"  label="full_name" track-by="id" :searchable="false"  :options-limit="20" :max-height="130" :selectLabel="null" :selectedLabel="null" :deselectLabel="null" :options="adminUsers" :multiple="false" :allow-empty="true"   :close-on-select="false" :clear-on-select="false"  placeholder="Assign Lead"></multiselect>
      </div>
    <div class="form-group" v-if="$can('lead_create_service_provide')">
      <label class="label-form">Services that we provide<span v-if="role_id != 6" style="color: red">*</span>:</label>
      <multiselect @input="showCogDropDown" v-model="demoForm.servicesValues" :options="servicesOptions" :multiple="true" :selectedLabel="null" :deselectLabel="null"  :selectLabel="null"
        :close-on-select="false" :clear-on-select="false" :internal-search="false" :allow-empty="true"
        :options-limit="20" :max-height="130" placeholder="Please select all that apply*">
      </multiselect>
    </div>
    <div v-if="showCog" class="form-group" >
      <label class="label-form">COG<span style="color: red">*</span>:</label>
      <multiselect v-model="demoForm.cogOptionsSelected" :options="cogOptions" :multiple="true" :selectedLabel="null" :deselectLabel="null"  :selectLabel="null"
        :close-on-select="false" :clear-on-select="false" :internal-search="false" :allow-empty="true" label="name" track-by="value"
        :options-limit="20" :max-height="130" placeholder="Please select all that apply*">
      </multiselect>
    </div>
    <div class="form-group" v-if="$can('lead_create_service_provide')">
      <textarea class="form-control" style="height: 42px" v-model="demoForm.answer"
        placeholder="How did you hear about us?"></textarea>
    </div>
    <div class="form-group" v-if="$can('lead_edit_implement_software')">
      <label class="label-form">When are you looking to implement the software?:</label>
      <multiselect :options="joinOptions" :internal-search="false" :allow-empty="true" :options-limit="20" :selectedLabel="null" :deselectLabel="null"  :selectLabel="null"
        :max-height="130" placeholder="Select expected time duration to use the software? " v-model="demoForm.joinValue"
        track-by="id">
      </multiselect>  
    </div>
    <div>
    <div class="form-group" >
      <h5 class="text-dark font-weight-bold py-2">Additional Information</h5>
      <label class="label-form-mini" style="float: left" v-if="$can('lead_create_number_decision_makers')">Number of Decision Makers:</label>
      <label class="label-form-mini" style="float: right" v-if="$can('lead_create_number_employees')">Number of Employees:</label>
      <input type="text" id="numberOfDecisionMakers" class="form-control-mini" v-model="additional_info.number_of_decion_makers"
        placeholder="Number of Decion Makers" v-if="$can('lead_create_number_decision_makers')"/>
      <input type="text" id="numberofEmployees" style="float: right" class="form-control-mini" v-model="additional_info.number_of_employees"
        placeholder="Number of Employees" v-if="$can('lead_create_number_employees')"/>
    </div>
    <div class="form-group" v-if="$can('lead_edit_implement_software')">
      <label class="label-form-mini" style="float: left" v-if="$can('lead_create_close_date')">Close Date:</label>
      <label class="label-form-mini" style="float: right" v-if="$can('lead_create_street_address')">Street Address:</label>
      <input  id="comanyCloseDate" class="form-control-mini" placeholder="Close Date"  v-model="additional_info.close_date" type="text" v-if="$can('lead_create_close_date')"/>
      <input type="text" id="companyStreetAddress" style="float: right" class="form-control-mini" v-model="additional_info.street_address"
        placeholder="Street Address" v-if="$can('lead_create_street_address')"/>
    </div>
    <div class="form-group" v-if="$can('lead_edit_implement_software')">
      <label class="label-form-mini" style="float: left" v-if="$can('lead_create_postal_code')"> Postal Code:</label>
      <label class="label-form-mini" style="float: right" v-if="$can('lead_create_timezone')">Timezone:</label>
      <input type="text" id="companyPostalCode" class="form-control-mini" v-model="additional_info.postal_code"
        placeholder="Postal Code" v-if="$can('lead_create_postal_code')"/>
      <input type="text" id="companyTimezone" style="float: right" class="form-control-mini" v-model="additional_info.timezone"
        placeholder="Timezone" v-if="$can('lead_create_timezone')" />
    </div>
    <div class="form-group">
      <label class="label-form-mini" style="float: left" v-if="$can('lead_create_year_founded')">Year Founded:</label>
      <label class="label-form-mini" style="float: right" v-if="$can('lead_create_facebook')">Facebook:</label>
      <input  id="comanyYearFounded" class="form-control-mini" placeholder="Year Founded" type="text"  v-model="additional_info.year_founded" v-if="$can('lead_create_year_founded')"/>

      <input type="text" id="companyFacebook" style="float: right" class="form-control-mini" v-model="additional_info.facebook"
        placeholder="Facebook Link" v-if="$can('lead_create_facebook')"/>
    </div>
    <div class="form-group">
      <label class="label-form-mini" style="float: left" v-if="$can('lead_create_google_plus')">Google Plus:</label>
      <label class="label-form-mini" style="float: right" v-if="$can('lead_create_twitter')" >Twitter:</label>
      <!-- <label class="label-form-mini" style="float: right">LinkedIn:</label> -->
      <input type="text" id="companyGoogle"  class="form-control-mini" v-model="additional_info.goole_plus"
        placeholder="Google Plus Link" v-if="$can('lead_create_google_plus')"/>
      <!-- <input type="text" id="companyLinkedin" style="float: right" class="form-control-mini" v-model="additional_info.linked_in"
        placeholder="LinkedIn Link" /> -->
        <input type="text" id="companyTwitter" style="float: right" class="form-control-mini" v-model="additional_info.twitter"
        placeholder="Twitter Link" v-if="$can('lead_create_twitter')"/>
    </div>
    <div class="form-group">
      <label class="label-form-mini" style="float: left" v-if="$can('lead_create_linkedin')">LinkedIn:</label>
      <label class="label-form-mini" style="float: right" v-if="$can('lead_create_job_title')">Job Title:</label>
      <input type="text" id="companyLinkedin" class="form-control-mini" v-model="additional_info.linked_in"
        placeholder="LinkedIn Link" v-if="$can('lead_create_linkedin')"/>
      <input type="text" id="jobTitle" style="float: right" class="form-control-mini" v-model="additional_info.job_title"
        placeholder="Job Title" v-if="$can('lead_create_job_title')"/>
    </div>
    <!-- <div class="form-group">
      <label class="label-form-mini" >Twitter:</label>
      <input type="text" id="companyTwitter" class="form-control" v-model="additional_info.twitter"
        placeholder="Twitter Link" />
    </div> -->
    </div>
    <!-- buttons -->
    <div class="form-footer text-right">
      <button type="button" class="btn btn-secondary text-light" data-dismiss="modal">
        Close
      </button>
      <button type="button" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-default text-light ml-1" @click="save">
        <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
        Save
      </button>
    </div>
  </form>
</template>
<script>
  import Multiselect from "vue-multiselect";
  import axios from 'axios';
  export default {
    components: {
      Multiselect
    },
    props: [
      'action', 'formData'
    ],
    data: function () {
      return {
        isMiniLoading: false,
        lead_for:[],
       lead_type: null,
        selected_tags:[],
        countries: [],
        servicesOptions: ['Linen Rentals', 'Customer Owned Goods', 'Dry Cleaning'],
        servicesValues: [],
        joinOptions: ['As Soon as Possible', 'Within One Month', 'Within Two Months', 'Three Months+', 'Not Sure Yet'],
        joinValue: [],
        demoForm: {},
        company_url: "",
        additional_info:{
          'number_of_decion_makers':'',
          'number_of_employees':'',
          'close_date':'',
          'street_address':'',
          'postal_code':'',
          'timezone':'',
          'year_founded':'',
          'facebook':'',
          'goole_plus':'',
          'linked_in':'',
          'twitter':'',
          'job_title':'',
        },
      //    selectLeadList: [
      //   { name: 'inbound', value: '1' },
      //   { name: 'outbound', value: '2' },
      // ],
        role_id:'',
        isMiniLoading2:false,
        adminUsers: [],
        selected: "",
        cogOptions:[
          { name: 'By Piece', value: '1' },
          { name: 'By Weight', value: '2' },
        ],
        cogOptionsSelected:[],
        showCog:false,
        userAssignedProduct :localStorage.getItem("user_product"),
      };
    },
    computed: {
       tags: function(){
        return this.$store.getters["users/tags"];
      },
      selectLeadList: function () {
        return this.$store.getters['persist/selectLeadList'];
      },
    },
    created: function () {
      // this.demoForm.lead_for ="LinenTech";
      this.role_id = JSON.parse(localStorage.getItem("role"));
      this.products =  this.$store.getters['persist/availableProducts'];
      this.products = this.products.filter(product =>
         this.userAssignedProduct.includes(product.id)
        );
     
        const permissionlist = {
          headers: {
            'X-Permission': 'lead_list'
          }
        };
        axios.get('/admin/users/get-all-users?role_id=' + 2,permissionlist)
            .then((response) => {
              let res = response.data;
              this.adminUsers = res.data;
            });
      
        const permission= {
          headers: {
            'X-Permission': 'lead_create_country'
          }
        };
        axios.get('admin/users/countries',permission).then((response) => {
          this.countries = response.data.countries;
        });
     

       
    },
    methods: {
async checkLead() {
    const { companyName, email } = this.demoForm;

  if (companyName && email) {
        try {
            const response = await axios.post(
                '/admin/users/auto-fill-leads',
                { companyName, email },
                {
                    headers: {
                        'X-Permission': 'lead_create'
                    }
                }
            );
            if (response.data && response.data.existing_lead) {
                const existingLead = response.data.existing_lead;
                this.demoForm.companyName=existingLead.company;
                this.demoForm.contactName=existingLead.name;
                this.demoForm = { ...this.demoForm,...existingLead};
                this.demoForm.lead_for = this.products.find(option => option.id === existingLead.lead_for);
                this.demoForm.lead_type= this.selectLeadList.find(option => option.name === existingLead.lead_type);
                this.demoForm.services= [
                 existingLead.rental ? 'Linen Rentals' : null,
                  existingLead.cog ? 'Customer Owned Goods' : null,
                   existingLead.dry_cleaning ? 'Dry Cleaning' : null
                  ].filter(Boolean);
                this.demoForm.cogOptionsSelected = existingLead.cog_type;
                this.demoForm.joinValue = existingLead.implement_date;
                this.demoForm.answer = existingLead.hear_about;
                  this.additional_info = {...this.additional_info, ...existingLead};
                     
           }
        } catch (error) {
            if (error.response && error.response.status === 404) {
                console.log('No existing data found.');
            } else {
                console.error('Error fetching data:', error);
            }
        }
    }
    else if(!companyName && !email){
      
       this.demoForm = {
            companyName: '',
            contactName: '',
            lead_for: null,
            selected_tags: [],
            servicesValues: [],
            cogOptionsSelected: null,
            joinValue: '',
            answer: ''
        };

        this.additional_info = {
            number_of_decion_makers: '',
            number_of_employees: '',
            close_date: '',
            street_address: '',
            postal_code: '',
            timezone: '',
            year_founded: '',
            facebook: '',
            goole_plus: '',
            linked_in: '',
            twitter: '',
            job_title: ''
        };
    }
},
 normalizePhone() {
          let formattedPhoneNumber = this.demoForm.phone.toString().replace(/\D/g, '');
          this.demoForm.phone = parseInt(formattedPhoneNumber) || '';
    },
      save() {
        let lead_type = this.demoForm.lead_type ? this.demoForm.lead_type.name : null;
        let tag_ids = (this.demoForm.selected_tags == undefined || this.demoForm.selected_tags.length <= 0)? [] : this.demoForm.selected_tags.map(({ id }) => id);
        let cog_types = ((this.demoForm.cogOptionsSelected == undefined || this.demoForm.cogOptionsSelected =='') || this.demoForm.servicesValues.indexOf('Customer Owned Goods') == -1 )?[] : this.demoForm.cogOptionsSelected.map(({ value }) => value);
        let user_id = localStorage.getItem('admin_id');
        let services; 
        if(this.demoForm.servicesValues != undefined){
          services = (this.demoForm.servicesValues.indexOf('Customer Owned Goods') != -1 && cog_types != '')|| (this.demoForm.servicesValues != undefined && this.demoForm.servicesValues.indexOf('Customer Owned Goods') == -1 && cog_types == ''); 
        }else if((this.demoForm.servicesValues == "" || this.demoForm.servicesValues == undefined) && this.role_id == 6){
          services = true;
        }else{
          services = false;
        }
        let assigned_to = (this.demoForm.selected == undefined || this.demoForm.selected =='') ? '':this.demoForm.selected.id;
        if ((this.demoForm.companyName != undefined && this.demoForm.lead_for != undefined && this.demoForm.contactName != undefined && this.demoForm.company_url != undefined && this.demoForm.email != undefined && this.demoForm.phone != undefined && this.demoForm.country != undefined && ((this.demoForm.servicesValues != undefined)||(this.demoForm.servicesValues == undefined && this.role_id == 6)))
          &&
          (this.demoForm.companyName != "" && this.demoForm.contactName != "" && this.demoForm.lead_for != "" && this.demoForm.company_url != "" && this.demoForm.email != "" && this.demoForm.phone != "" && this.demoForm.country != "" && (this.demoForm.servicesValues != ""||((this.demoForm.servicesValues == ""||this.demoForm.servicesValues == undefined ) && this.role_id == 6)))
          ) {
          if(services){
              if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.demoForm.email)) {
                if(/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(this.demoForm.company_url)){
                  this.create(this.demoForm, user_id,tag_ids,assigned_to,cog_types,lead_type);
                }else{
                    this.$toast.error('Please enter a valid URL');
                }
              }else{
                this.$toast.error('Please enter a valid email address');
              }
          }else{
            this.$toast.error('Please select COG types');
          }  
        }
        else {
          this.$toast.warning('Fill all required Fields');
        }
      },
      create(demoForm, user_id, tag_ids,assigned_to,cog_types,lead_type) {
      



        this.isMiniLoading = true;
        let self = this;
        this.$store.dispatch('users/createDemoRequest', [demoForm, user_id, this.additional_info,tag_ids,assigned_to,cog_types,lead_type]).then((resp) => {
          this.isMiniLoading = false;
          if(resp.error){
            if(this.demoForm.lead_for == 1 ){
              this.demoForm.lead_for = "TheStaffer";
            }else{
              this.demoForm.lead_for = "LinenTech";
            }
            this.isMiniLoading = false;
            this.$toast.error(resp.error);
          }else{
            
            
            this.$toast.success(`Lead for ${demoForm.companyName} has been added successfully`);
            
            let software;
            this.$store.dispatch('users/getAllDemoRequests', [1, "", localStorage.getItem('tab') != null ? localStorage.getItem('tab') : 'all', this.formData.status, "", "", "", "", "",'','all', localStorage.getItem('demo_filter') != null ? localStorage.getItem('demo_filter') : 'all','all','all',software])
             .then(() => {
              self.demoForm = {};
              this.additional_info = {};
              window.$('#modal').modal('hide');
              });
         
            // this.$router.go();
          }
          
          })
          .catch((error) => {
        
            this.isMiniLoading = false;
            this.$toast.error(error);
          });
      },
      
   
      checkWebsiteStatus(){
                this.isMiniLoading2 = true;
                setTimeout(() => {
                  if(this.demoForm.company_url != '' && this.demoForm.lead_for != undefined){
                    if(/[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g.test(this.demoForm.company_url)){
                      this.$store.dispatch('users/checkLeadsWebsiteStatus',[this.demoForm.company_url,this.demoForm.lead_id,this.demoForm.lead_for.id])
                      .then((error ) => {
                          this.company_url = error;
                          this.isMiniLoading2 = false;
                      });
                    }else{
                      this.company_url = "Please Enter a Valid URL";
                      this.isMiniLoading2 = false;
                    }
                    
                  }else{
                    this.company_url = '';
                    this.isMiniLoading2 = false;
                  }
                  
                  // this.isMiniLoading2 = false;
                }, 300);
                
                
            },
      showCogDropDown(){
        if(this.demoForm.servicesValues.indexOf('Customer Owned Goods') != -1){
          this.showCog = true;
        }else{
          this.showCog = false;
          this.cogOptionsSelected = [];
        }
      },
    },
  };
</script>
<style scoped>
input[type="date"]{
  position: relative;
}
input[type="date"]::-webkit-calendar-picker-indicator {
    background-position: right;
    background-size: auto;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
    top: 12px!important;
    right: 2%;
    width: auto;
}
.text-dark{
    color: rgb(72, 166, 166) !important;
}
</style>